<main>
	<h2 class="titel">Home</h2>
	<img id="lets-afbeelding" src="./images/fotokader.jpg" alt="" />
	<p>
		Wij zijn LETSers, leden van een netwerk van mensen die wel eens iets voor elkaar willen doen. <br>
We hebben een heel ruime regio, wat zorgt dat er veel vraag en aanbod is. <br>
We hebben leden in alle gemeenten van deze regio. Er zijn geen LETSgroepen voor elke stad/gemeente apart. Wij hebben liever een ruime vraag en aanbod, je kiest toch zelf hoe ver je wil gaan om te LETSen. <br>
Wij kunnen LETSen (voor ons is dat een werkwoord ;-) met onze eigen leden maar ook makkelijk interLETSen met LETS Merelbeke, LETS Dendermonde en nog een 10-tal andere LETSgroepen. <br>
Wij kunnen helaas niet interLETSen met enkele lokale groepen die kozen voor een andere software.
	</p>
	<p>
		&rarr; Je vindt de letsgroepen ook op <a target="_blank" href="http://www.letsvlaanderen.be/">www.letsvlaanderen.be</a> bij 'groepen'.
	</p>
</main>

<style lang="css">
	main {
		padding: 1em;
		margin: 0 auto;
	}

	#lets-afbeelding {
		width: 100%;
		height: 71%;
	}

	
</style>
